import React from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

import EditIcon from '@material-ui/icons/Edit';
import MyLocation from "@material-ui/icons/MyLocation";
import MailOutline from "@material-ui/icons/MailOutline";
import LocationOn from "@material-ui/icons/LocationOn";
import Map from "@material-ui/icons/Map";

import withStyles from "@material-ui/core/styles/withStyles";

import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CustomInput from "components/CustomInput/CustomInput.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";
import Api from "../../../api/Api.js";
import CustomerEndpoints from "../../../api/CustomerEndpoints";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  }
};
class Addresses extends React.Component {

  constructor(props) {
    super(props);

    var newPhysical = { address: '', postal_code: '' };
    var newPostal = { address: '', postal_code: '' };

    if (props.physical && props.postal) {
      newPhysical.postal_code = props.physical.postal_code;
      newPostal.postal_code = props.postal.postal_code;

      for (var i = 1; i <= 5; i++) {
        if (props.physical["address_line_" + i])
          newPhysical.address += props.physical["address_line_" + i] + "\n"

        if (props.postal["address_line_" + i])
          newPostal.address += props.postal["address_line_" + i] + "\n"
      }

      newPostal.address = newPostal.address.trim();
      newPhysical.address = newPhysical.address.trim();
    }

    console.log("customer_id: " + props.customer_id);

    this.state = {
      open_physical: false,
      physical_loading: false,
      open_postal: false,
      postal_loading: false,
      physical: {
        ...newPhysical
      },
      postal: {
        ...newPostal
      }
    }
  }

  saveChanges(address_type) {
    this.setState({ [address_type + "_loading"]: true }, () => {
      Api.post(CustomerEndpoints.setAddress, { ...this.state[address_type], address_type, customer_id: this.props.customer_id })
        .then(() => {
          this.setState({ [address_type + "_loading"]: false, ["open_" + address_type]: false });
          if (this.props.onRefreshRequired) {
            this.props.onRefreshRequired();
          }
        })
        .catch((e) => {
          this.setState({ [address_type + "_loading"]: false });
          console.error(e);
        })
    })
  }

  componentDidUpdate() {
    var newPhysical = { address: '', postal_code: '' };
    var newPostal = { address: '', postal_code: '' };

    if (this.props.physical && this.props.postal && !this.state.postal.postal_code && !this.state.physical.postal_code) {
      newPhysical.postal_code = this.props.physical.postal_code;
      newPostal.postal_code = this.props.postal.postal_code;

      for (var i = 1; i <= 5; i++) {
        if (this.props.physical["address_line_" + i])
          newPhysical.address += this.props.physical["address_line_" + i] + "\n"

        if (this.props.postal["address_line_" + i])
          newPostal.address += this.props.postal["address_line_" + i] + "\n"
      }

      newPostal.address = newPostal.address.trim();
      newPhysical.address = newPhysical.address.trim();

      this.setState({ postal: newPostal, physical: newPhysical });
    }
  }

  renderAddressLines(address) {
    var out = [];

    for (var i = 1; i <= 5; i++) {
      if (address["address_line_" + i])
        out.push(<h5 key={i}>{address["address_line_" + i]}</h5>)
    }

    return out;
  }

  render() {

    const { classes } = this.props;

    return (
      <GridContainer>
        <GridItem key="physical" xs={6}>
          <h3>Physical Address <IconButton onClick={() => this.setState({ open_physical: true })}><EditIcon color="action" /></IconButton></h3>
          {
            this.props.physical ?
              [
                this.renderAddressLines(this.props.physical),
                <h5>{this.props.physical.postal_code}</h5>
              ]
              :
              <h5>N/A</h5>
          }
        </GridItem>
        <GridItem key="postal" xs={6}>
          <h3>Postal Address <IconButton onClick={() => this.setState({ open_postal: true })}><EditIcon color="action" /></IconButton></h3>
          {
            this.props.postal ?
              [
                this.renderAddressLines(this.props.postal),
                <h5>{this.props.postal.postal_code}</h5>
              ]
              :
              <h5>N/A</h5>
          }
        </GridItem>

        <Dialog
          open={this.state.open_physical}
          onClose={() => this.setState({ open_physical: false })}
          fullWidth
          maxWidth="sm"
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title"><LocationOn style={{ marginBottom: -5 }} /> Edit Physical Address</DialogTitle>
          <DialogContent>
            <CustomInput
              success={this.state.physical.addressState === "success"}
              error={this.state.physical.addressState === "error"}
              labelText={
                <span>
                  Address <small>(required)</small>
                </span>
              }
              id="physical.address"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: e => {
                  if (e.target.value.split('\n').length <= 5)
                    this.setState({ physical: { ...this.state.physical, address: e.target.value } })
                },
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className={classes.inputAdornment}
                  >
                    <Map className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                value: this.state.physical.address,
                multiline: true,
                rowsMax: 5
              }}
            />
            <CustomInput
              success={this.state.physical.postal_codeState === "success"}
              error={this.state.physical.postal_codeState === "error"}
              labelText={
                <span>
                  Postal Code <small>(required)</small>
                </span>
              }
              id="physical.postal_code"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: e => this.setState({ physical: { ...this.state.physical, postal_code: e.target.value } }),
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className={classes.inputAdornment}
                  >
                    <MyLocation className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                value: this.state.physical.postal_code,
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button style={{ marginRight: 'auto' }} round onClick={() => this.setState({ open_physical: false })} color="rose" simple>
              Cancel
            </Button>

            {
              this.state.postal_loading ?
                <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                :
                <Button
                  onClick={() => this.saveChanges("physical")}
                  color="rose"
                  round
                >
                  Save Changes
                  &nbsp;&nbsp;
              <FontAwesomeIcon icon={faCheck} />
                </Button>
            }
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.open_postal}
          onClose={() => this.setState({ open_postal: false })}
          fullWidth
          maxWidth="sm"
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title"><MailOutline style={{ marginBottom: -5 }} /> Edit Postal Address</DialogTitle>
          <DialogContent>
            <CustomInput
              success={this.state.postal.addressState === "success"}
              error={this.state.postal.addressState === "error"}
              labelText={
                <span>
                  Address <small>(required)</small>
                </span>
              }
              id="postal.address"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: e => {
                  if (e.target.value.split('\n').length <= 5)
                    this.setState({ postal: { ...this.state.postal, address: e.target.value } })
                },
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className={classes.inputAdornment}
                  >
                    <Map className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                value: this.state.postal.address,
                multiline: true,
                rowsMax: 5
              }}
            />
            <CustomInput
              success={this.state.postal.postal_codeState === "success"}
              error={this.state.postal.postal_codeState === "error"}
              labelText={
                <span>
                  Postal Code <small>(required)</small>
                </span>
              }
              id="postal.postal_code"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: e => this.setState({ postal: { ...this.state.postal, postal_code: e.target.value } }),
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className={classes.inputAdornment}
                  >
                    <MyLocation className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                value: this.state.postal.postal_code,
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button style={{ marginRight: 'auto' }} round onClick={() => this.setState({ open_postal: false })} color="rose" simple>
              Cancel
            </Button>

            {
              this.state.postal_loading ?
                <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                :
                <Button
                  onClick={() => this.saveChanges("postal")}
                  color="rose"
                  round
                >
                  Save Changes
                  &nbsp;&nbsp;
                  <FontAwesomeIcon icon={faCheck} />
                </Button>
            }
          </DialogActions>
        </Dialog>
      </GridContainer>
    );
  }
}

export default withStyles({ ...extendedFormsStyle, ...style })(Addresses);